<template>
  <div>
    <div>
      <b-form-group v-if="isTopazIntalled && !value" label="Mode">
        <b-form-radio-group v-model="padType">
          <b-row>
            <b-col>
              <b-form-radio value="topaz">Topaz</b-form-radio>
            </b-col>
            <b-col>
              <b-form-radio value="mouse">Mouse</b-form-radio>
            </b-col>
          </b-row>
        </b-form-radio-group>
      </b-form-group>
      <div class="d-flex flex-row justify-content-center w-100">
        <div class="w-100">
          <VueSignaturePad
            class="border mx-auto bg-white rounded-lg"
            width="466px"
            height="150px"
            ref="signaturePad"
            :style="{
              display: padType == 'mouse' && !value ? 'block' : 'none'
            }"
          />
          <canvas
            :style="{
              display: padType == 'topaz' && !value ? 'block' : 'none'
            }"
            class="border mx-auto bg-white rounded-lg"
            ref="topaz-canvas"
            width="466"
            height="150"
          />
          <img v-if="value" style="width: 100%;" :src="value.signature" />
          <div class="d-flex flex-row justify-content-between w-100 mt-2">
            <div>
              <a
                href="#"
                @click="useMySignature"
                v-if="currentUser && currentUser.signature && !value"
                style="font-size:14px; padding-left:7px;"
                >Use My Signature</a
              >
            </div>
            <div>
              <a
                href="#"
                @click="clearSignatureForm"
                style="font-size:14px; padding-right:7px;"
                >Clear All</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatDateTimeSql } from "../../helpers/date";

let tabletState = null;

export default {
  name: "Signature",
  props: ["disabled", "value"],
  data() {
    return {
      padType: "mouse"
    };
  },
  mounted() {
    this.showSignPadShown();
    this.initializeTopazPad();
  },
  beforeDestroy() {
    this.disconectSigWeb();
  },
  methods: {
    showSignPadShown() {
      setTimeout(() => {
        this.$refs.signaturePad.resizeCanvas();
      }, 250);
    },
    getSignatureValue() {
      let signatureValue = this.value;
      if (!signatureValue) {
        if (this.padType == "topaz") {
          let signatureCanvas = this.$refs["topaz-canvas"];
          let canvasContext = signatureCanvas.getContext("2d");
          const pixelBuffer = new Uint32Array(
            canvasContext.getImageData(
              0,
              0,
              signatureCanvas.width,
              signatureCanvas.height
            ).data.buffer
          );
          let signatureEmpty = !pixelBuffer.some(color => color !== 0);
          if (!signatureEmpty) {
            window.SetSigCompressionMode(1);
            let signatureString = window.GetSigString();

            window.SetDisplayXSize(440);
            window.SetDisplayYSize(100);
            window.SetJustifyMode(0);
            window.ClearTablet();
            window.SetSigCompressionMode(1);
            window.SetSigString(signatureString, canvasContext);
            window.SetJustifyMode(5);
            window.SetTabletState(0, tabletState);
            let imgSignature = signatureCanvas.toDataURL();

            signatureValue = {
              signature: `${imgSignature}`,
              ...this.getSignatureMetadata()
            };
          }
        } else {
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
          if (!isEmpty) {
            signatureValue = {
              signature: data,
              ...this.getSignatureMetadata()
            };
          }
        }
      }
      return signatureValue;
    },
    disconectSigWeb() {
      console.log("disconnecting");
      if (this.isTopazIntalled) {
        window.ClearTablet();
        window.SetTabletState(0, tabletState);
        clearInterval(tabletState);
      }
    },
    clearSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 250);
      }
      if (this.isTopazIntalled) {
        window.ClearTablet();
      }
    },
    clearSignatureForm() {
      this.$emit("input", null);
      this.clearSignature();
    },
    useMySignature() {
      this.$emit("input", {
        signature: this.currentUser.signature,
        ...this.getSignatureMetadata()
      });
    },
    initializeTopazPad() {
      const self = this;
      setTimeout(() => {
        try {
          self.padType = self.isTopazIntalled ? "topaz" : "mouse";
          if (self.isTopazIntalled) {
            let signatureCanvas = self.$refs["topaz-canvas"];
            let canvasContext = signatureCanvas.getContext("2d");
            window.SetDisplayXSize(500);
            window.SetDisplayYSize(100);
            window.SetTabletState(0, tabletState);
            window.SetJustifyMode(0);
            tabletState =
              window.SetTabletState(1, canvasContext, 50) || tabletState;
            window.ClearTablet();
          }
        } catch (e) {
          self.isTopazIntalled = false;
          // If exception throws, means the current machine doesn't have the SignaturePad driver.
        }
      }, 250);
    },
    getSignatureMetadata() {
      return {
        date: formatDateTimeSql(this.getCurrentAdjustedDateTime()),
        user: this.currentUser
          ? {
              id: this.currentUser.id,
              firstName: this.currentUser.firstName,
              lastName: this.currentUser.lastName,
              middleName: this.currentUser.middleName,
              credentials: this.currentUser.credentials
            }
          : ""
      };
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      isTopazIntalled: state => state.isTopazIntalled
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"])
  },
  watch: {
    padType: function(newValue) {
      if (newValue == "mouse") {
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 250);
      }
    }
  }
};
</script>
